import React from 'react';
import PropTypes from 'prop-types';

const CourseInfoRow = ({ title, description }) => (
    description ? (
        <span key={title} className="nr-block__info">
            <span className="nr-block__infoTitle">
                {title}:&nbsp;
            </span>
            <span className="nr-block__infoDescription">
                {description}
            </span>
        </span>
    ) : null
);

CourseInfoRow.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
};

export default CourseInfoRow;



// WEBPACK FOOTER //
// ./src/js/nonRunners/components/CourseInfoRow.jsx